module.exports = __webpack_public_path__ + "piaggio.2abc97bddff89108525d.png";